import { useEffect, useRef, useState } from "react";

// Lazy-mount the shelf 1500px before it enters the viewport. This keeps the
// initial page render lean on long pages (20+ shelves) without exposing users
// to the flash we'd get from JIT-mounting when the shelf actually appears.
export const useShelfMount = (enabled) => {
  const sectionRef = useRef(null);
  const [isMounted, setIsMounted] = useState(!enabled);

  useEffect(() => {
    if (!enabled || isMounted) return;
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setIsMounted(true);
          observer.disconnect();
        }
      },
      { rootMargin: "1500px 0px", threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled, isMounted]);

  return { sectionRef, isMounted };
};
